import React from 'react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_MEGAPACK, CHECKOUT_MEGAPACK_KIT } from '../data/content';
type Plan = {
  emoji: string;
  name: string;
  includes: string;
  idealFor: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
  featured: boolean;
};
const plans: Plan[] = [{
  emoji: '📘',
  name: 'MegaPack Caligrafía y Lectoescritura',
  includes: '6 Tomos + 6 Bonos · Tomo 1 → Tomo 6 · Todos los niveles',
  idealFor: 'familias que acompañan el aprendizaje en casa y docentes de nivel inicial y primer ciclo.',
  oldPrice: '$51.000',
  price: '$19.990 ARS',
  cta: '→ Quiero mi MegaPack',
  href: CHECKOUT_MEGAPACK,
  featured: false
}, {
  emoji: '🏆',
  name: 'MegaPack + Kit Inclusión',
  includes: '6 Tomos + 6 Bonos + Kit Lectoescritura Sin Barreras',
  idealFor: 'docentes con grupos heterogéneos, NEE, niveles mixtos y familias con niños/as con dificultades de aprendizaje.',
  oldPrice: '$69.000',
  price: '$27.990 ARS',
  cta: '→ Quiero el MegaPack + Kit Inclusión',
  href: CHECKOUT_MEGAPACK_KIT,
  featured: true
}];
export function Pricing() {
  return <section id="precios" aria-labelledby="precios-titulo" className="w-full bg-white py-14 sm:py-20" data-id="element-221" data-mp="4uyrmqgjrq5i">
      <div className="mx-auto max-w-5xl px-5" data-id="element-222" data-mp="erblppg0860s">
        <h2 id="precios-titulo" className="text-center font-display text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-223" data-mp="eq0k9wa17acu">
          🇦🇷 Elegí tu MegaPack
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-224" data-mp="3i93jjkgtnk6w">
          {plans.map(plan => <article key={plan.name} className={`relative flex flex-col rounded-3xl border-2 p-6 sm:p-7 ${plan.featured ? 'border-gold bg-navy text-white shadow-pop' : 'border-navy/10 bg-cream text-navy shadow-card'}`} data-id="element-225" data-mp="3n63ry2158z16">
              {plan.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gold px-4 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy-deep" data-id="element-226" data-mp="2rguzve1otwdq">
                  ⭐ Más elegido
                </span>}

              <h3 className="mt-2 font-display text-xl font-extrabold leading-tight sm:text-2xl" data-id="element-227" data-mp="318qz4sfifsjj">
                <span aria-hidden="true" data-id="element-228" data-mp="2w9o50312j6qc">{plan.emoji} </span>
                {plan.name}
              </h3>
              <p className={`mt-2 text-sm font-bold ${plan.featured ? 'text-gold' : 'text-celeste-dark'}`} data-id="element-229" data-mp="28jtu3r0b7s8q">
                {plan.includes}
              </p>
              <p className={`mt-4 text-sm leading-relaxed ${plan.featured ? 'text-white/75' : 'text-navy/70'}`} data-id="element-230" data-mp="2ie3m37lcaoix">
                <strong className="font-bold" data-id="element-231" data-mp="3tutvezl27wgr">Ideal para:</strong> {plan.idealFor}
              </p>

              <div className="mt-auto pt-7" data-id="element-232" data-mp="3ows45rdhcqu7">
                <p className={`text-base font-bold line-through ${plan.featured ? 'text-white/50' : 'text-navy/40'}`} data-id="element-233" data-mp="3ovz6dfwi1bo7">
                  {plan.oldPrice}
                </p>
                <p className="font-display text-4xl font-extrabold leading-none sm:text-5xl" data-id="element-234" data-mp="57dpgwwd2o80">
                  {plan.price}
                </p>

                <CtaButton href={plan.href} variant={plan.featured ? 'primary' : 'secondary'} className="mt-6 w-full text-center" data-id="element-235" data-mp="3rfwubmtp1gpc">
                  {plan.cta}
                </CtaButton>
                <p className={`mt-3 text-center text-xs font-semibold ${plan.featured ? 'text-celeste-light' : 'text-navy/60'}`} data-id="element-236" data-mp="o1sqst65asz0">
                  ⚡ Acceso en 5 minutos · 🛡️ Garantía 7 días
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}